module.exports = import("https://cdn.skypack.dev/html2canvas@1.4.1");;